import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import composePaginationLinkTo from './composePaginationLinkTo';
import getPageOffset from './getPageOffset';
import { useSearchQuestion, useSearchResults } from '@context/DataContext';

const PaginationItem = ({ isCurrent = false, itemType = 'link', pageNumber }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { pagination } = useSearchResults();
  const { setPage } = useSearchQuestion();
  const { limit } = pagination;

  const currentClass = isCurrent ? 'active' : '';
  const label = (
    <>
      <span className="visuallyhidden">page</span>
      {pageNumber}
    </>
  );

  const pageOffset = getPageOffset(pageNumber, limit);

  const isLink = itemType === 'link';
  const linkTo = isLink && !isCurrent ? composePaginationLinkTo(pageNumber, pagination.limit, searchParams) : '';

  const handleLinkClick = () => {
    setPage(pageNumber);
  };

  const handleButtonClick = () => {
    const newSearchParams = new URLSearchParams(searchParams);
    setPage(pageNumber);
    newSearchParams.set('start_rank', String(pageOffset));
    setSearchParams(newSearchParams);
  };

  return (
    <li className={`base-search-pagination-list__item ${currentClass}`}>
      {isLink ? (
        isCurrent ? (
          // <span className="base-search-pagination-list__link">{label}</span>
          <a href="#" aria-label={`page ${[pageNumber]}`} aria-current="page" className="base-search-pagination-list__link">
            {label}
          </a>
        ) : (
          <Link to={linkTo} className="base-search-pagination-list__link" onClick={handleLinkClick}>
            {label}
          </Link>
        )
      ) : (
        <button type="button" disabled={isCurrent} onClick={handleButtonClick}>
          {label}
        </button>
      )}
    </li>
  );
};

export default PaginationItem;
